/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2022-12-05 15:37:53
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\specialmaterial\income.js
 */
/**
 * @version 1.0.0
 * @author fxg1997
*/
export const queryPage = '/icps/system/sign/intelligent/materials/incoming/queryPage'
export const saveOrUpdate = '/icps/system/sign/intelligent/materials/incoming/saveOrUpdate'
import request from '@/utils/request'
//特材原料-成品管理，分页查询
export function productList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/product/queryPage',
    method: 'post',
    data
  })
}
//供应商，分页查询
export function stationList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/supplier/queryPage',
    method: 'post',
    data
  })
}
//分页查询特材罐
export function tankList(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/tank/queryPage',
    method: 'post',
    data
  })
}
//检验或入库
export function checkOrIncoming(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/incoming/checkOrIncoming',
    method: 'post',
    data
  })
}
//检验或入库
export function warehousing(data) {
  return request({
    url: '/icps/system/sign/intelligent/materials/incoming/warehousing',
    method: 'post',
    data
  })
}
//特材原料列表
export function querySpecialList(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/querySpecialList',
    method: 'get',
    params
  })
}
//特材原料列表
export function getRawContracts(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/incoming/getRawContracts',
    method: 'get',
    params
  })
}
//特材原料列表
export function getSpecialMaterialsById(params) {
  return request({
    url: '/icps/system/sign/intelligent/materials/specialMaterials/getSpecialMaterialsById',
    method: 'get',
    params
  })
}